import { features } from '@/mocks/features';

export default function FeatureSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100/80 text-accent-700 text-xs font-medium mb-4 whitespace-nowrap">
            Why Choose Us
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-3">
            Why Vigorbuy Spreadsheet?
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            Experience a smarter way to discover products with our organized, intuitive platform designed for effortless browsing.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {features.map((feature) => (
            <div
              key={feature.id}
              className="group p-5 md:p-6 bg-background-50 border border-background-200/70 rounded-xl hover:border-accent-200 transition-all duration-300"
            >
              <div className="w-11 h-11 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 group-hover:bg-accent-500 group-hover:text-background-50 transition-colors duration-300 mb-4">
                <i className={`${feature.icon} text-lg`}></i>
              </div>
              <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 mb-2">
                {feature.title}
              </h3>
              <p className="text-foreground-600 text-sm leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}